.wrapper {
  /* Wide tables scroll INSIDE their own container. Without this the page body
     scrolls sideways and the sidebar drifts off screen. */
  overflow-x: auto;
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--text-base);
}

.refreshing {
  opacity: 0.6;
  transition: opacity var(--transition);
  pointer-events: none;
}

.headCell {
  text-align: left;
  padding: var(--space-3) var(--space-4);
  font-size: var(--text-xs);
  font-weight: var(--weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
  background: var(--bg-sunken);
  border-bottom: 1px solid var(--border);
  white-space: nowrap;

  /* The header stays visible while a long list scrolls — otherwise an admin
     forty rows down has no idea which column is which. */
  position: sticky;
  top: 0;
  z-index: 1;
}

.cell {
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--border);
  color: var(--text);
  vertical-align: middle;
}

tbody tr:last-child .cell {
  border-bottom: none;
}

tbody tr:hover .cell {
  background: var(--bg-hover);
}

.clickable {
  cursor: pointer;
}

.right  { text-align: right; }
.center { text-align: center; }

/* ------------------------------------------------------------- responsive */
@media (max-width: 900px) {
  .secondary { display: none; }
}

/* -------------------------------------------------------------- skeleton */
.skeletonRow .cell { border-bottom: 1px solid var(--border); }

.skeleton {
  display: block;
  height: 14px;
  width: 70%;
  border-radius: var(--radius-sm);
  background: linear-gradient(
    90deg,
    var(--bg-sunken) 25%,
    var(--bg-hover) 50%,
    var(--bg-sunken) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.4s ease-in-out infinite;
}

@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ----------------------------------------------------------- empty/error */
.stateBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-7) var(--space-5);
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  text-align: center;
}

.stateTitle {
  font-weight: var(--weight-semibold);
  color: var(--text);
}

.stateBody {
  color: var(--text-muted);
  font-size: var(--text-base);
  max-width: 42ch;
}

.retry {
  margin-top: var(--space-2);
  padding: var(--space-2) var(--space-4);
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  color: var(--indigo);
  background: transparent;
  border: 1px solid var(--indigo);
  border-radius: var(--radius);
}

.retry:hover {
  background: var(--indigo);
  color: #fff;
}
